/**
 * Define a reducer and the default state for this reducer here 'reducer.ts'
 */
/** *** */
import { produce } from "immer";
import type { tConnectionManagerAction, tConnectionManagerState, tSetStatusAction } from "./types";

const kDefaultConnectionManagerState: tConnectionManagerState = {
  status: "complete",
};

type tpHandleSetStatus = (state: tConnectionManagerState, action: tSetStatusAction) => tConnectionManagerState;
const handleSetStatus: tpHandleSetStatus = (state, action) => {
  state.status = action.data.status;
  return state;
};

export const ConnectionManagerReducer = produce(
  (
    state: tConnectionManagerState = kDefaultConnectionManagerState,
    action: tConnectionManagerAction,
  ): tConnectionManagerState => {
    switch (action.type) {
      case "SET_STATUS":
        return handleSetStatus(state, action);
      default:
        return state;
    }
  },
);
